module.exports = __webpack_public_path__ + "static/media/3-3.b89ea0c8.png";